export const module = {
  info: {
    name: 'voip-customer-rate',
    caption: 'voip customer rate'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
}

export default module
